<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'font-size',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Font Size',
            tailwindDefinitionProp: 'fontSize',
        };
    },
};
</script>
